/* tslint:disable */

declare var Object: any;
export interface DocumentProxyInterface {
  "id"?: number;
}

export class DocumentProxy implements DocumentProxyInterface {
  "id": number;
  constructor(data?: DocumentProxyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DocumentProxy`.
   */
  public static getModelName() {
    return "DocumentProxy";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DocumentProxy for dynamic purposes.
  **/
  public static factory(data: DocumentProxyInterface): DocumentProxy{
    return new DocumentProxy(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DocumentProxy',
      plural: 'document-proxy',
      path: 'document-proxy',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
